import styled from 'styled-components'

export const ConfigHeaderTimespanContainer = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: flex-end;
    position: relative;

    .label {
        color: ${({ theme }) => theme['gray-800']};
    }
    .configheaderfilter-clickable {
        height: 27px;
        border-radius: 3px;
        border: 1px solid ${({ theme }) => theme['gray-400']};
        display: flex;
        gap: 6px;
        align-items: center;
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        color: #606a80;
        padding: 0 8px;
        width: 260px;
        justify-content: space-between;

        .fa-caret-down {
            font-weight: 900;
            color: ${({ theme }) => theme['blue-500']};
        }
        .fa-caret-up {
            font-weight: 900;
            color: ${({ theme }) => theme['blue-500']};
        }

        .fa-link {
            font-weight: 900;
            color: ${({ theme }) => theme['blue-500']};
            padding-right: 8px;
        }
    }

    .configheaderfilter-clickable:hover {
        cursor: pointer;
    }
`

export const TimeSpanContainer = styled.div`
    padding: 24px 16px 0px 16px;
    font-size: 13px;
    color: ${({ theme }) => theme['gray-800']};
    background: ${({ theme }) => theme['gray-100']};
    border: solid 1px ${({ theme }) => theme['gray-300']};
    position: absolute;
    top: calc(100%);
    z-index: 100;

    .title {
        /* border-top: 1px solid; */
        /* border-color: ${({ theme }) => theme['gray-300']};
        margin-right: 24px; */
        padding: 0 0 16px 0;
    }

    span {
        font-weight: 700;
    }

    .timespan {
        background: black;
        width: calc(100% - 16px);
        height: 250px;
    }

    .react-datepicker__navigation--next {
        color: #efefef;
        width: 16px;
        height: 10px;
        padding: 0;
        max-width: 0ch;
        overflow: hidden;
        padding-right: 5px;
        background: transparent;
    }

    .react-datepicker__navigation--previous {
        color: #efefef;
        width: 16px;
        height: 10px;
        padding: 0;
        max-width: 0ch;
        overflow: hidden;
        padding-left: 5px;
        background: transparent;
    }
    .react-datepicker__current-month {
        text-transform: capitalize;
        padding-bottom: 16px;
        font-size: 16px;
        font-weight: 600;
    }
    .react-datepicker__header {
        background: transparent;
        border: none;
    }
    .react-datepicker {
        border: none;
        background: transparent;
    }

    .react-datepicker__day,
    .react-datepicker__day-name {
        color: ${({ theme }) => theme['gray-700']} !important;
    }

    .react-datepicker__current-month {
        color: ${({ theme }) => theme['gray-800']} !important;
    }

    .react-datepicker__day--outside-month {
        color: ${({ theme }) => theme['gray-500']} !important;
    }

    .react-datepicker__day:hover {
        background-color: ${({ theme }) => theme['gray-300']} !important;
        color: ${({ theme }) => theme['gray-900']} !important;
    }

    .react-datepicker__day--selected {
        background-color: ${({ theme }) => theme['blue-300']} !important;
        color: ${({ theme }) => theme['gray-900']} !important;
        font-weight: 600;
    }
`

export const TimeInput = styled.div`
    margin-top: 12px;
    width: 224px;
    height: 104px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 16px 0;

    .start-control {
        width: 88px;

        span {
            font-size: 13px;
            font-weight: 600;
        }

        .input {
            border: none;
            width: 88px;
            height: 28px;
            margin-top: 4px;
            background: transparent;
            padding: 0;
            border-bottom: 1px solid;
            border-color: ${({ theme }) => theme['gray-300']};
        }
    }

    .space {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 0 14px;

        .line {
            width: 1px;
            height: 30px;
            background: ${({ theme }) => theme['gray-300']};
        }
    }
`

export const TimeSelectList = styled.div`
    padding: 18px 0 0;
    display: flex;

    .timeControl {
        width: 95px;
        height: 116px;
    }

    .timeControl + .timeControl {
        margin-left: 21px;
    }

    button {
        background: transparent;
        border: none;
        font-size: 11px;
        font-weight: 600;
        color: ${({ theme }) => theme['gray-600']};
        padding: 4px 0px;
        width: 100%;
        text-align: left;
    }
`
export const SaveBar = styled.div`
    padding: 16px 0;
    border-top: 1px solid;
    border-color: ${({ theme }) => theme['gray-300']};
`

export const SaveButton = styled.button`
    border: 1px solid;
    border-color: ${({ theme }) => theme['blue-500']};
    text-transform: capitalize;
    color: ${({ theme }) => theme['gray-0']};
    background: ${({ theme }) => theme['blue-500']};
    padding: 4px 16px;
    &.disabled {
        background: ${({ theme }) => theme['blue-400']};
        border-color: ${({ theme }) => theme['blue-400']};
    }
`

export const CancelButton = styled.button`
    text-transform: capitalize;
    border: 1px solid;
    border-color: ${({ theme }) => theme['gray-300']};
    text-transform: capitalize;
    color: ${({ theme }) => theme['gray-800']};
    background: transparent;
    margin-left: 8px;
    padding: 4px 16px;
`
